import { Link } from "react-router-dom";
import ArticleCard from "@/components/feature/ArticleCard";
import { articles } from "@/mocks/articles";

export default function LatestFeed() {
  const feed = articles.slice(0, 6);

  return (
    <section className="w-full">
      <div className="mb-8 flex flex-col gap-2 md:flex-row md:items-end md:justify-between">
        <div>
          <h2 className="font-heading text-2xl font-700 text-foreground-950 md:text-3xl">最新鉴定流</h2>
          <p className="mt-2 text-sm text-foreground-600">刚刚核实完的条目，结论与依据同步更新。</p>
        </div>
        <Link
          to="/verify"
          className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-500 text-primary-700 transition-colors hover:text-primary-800"
        >
          进入鉴定专区
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {feed.map((a) => (
          <ArticleCard key={a.id} article={a} />
        ))}
      </div>
    </section>
  );
}